"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompositeChartJSONModel = void 0;
const lodash_1 = __importDefault(require("lodash"));
const AutoSequenceJSONModel_1 = require("src/hello_assets/src/components/model/common/AutoSequenceJSONModel");
const PeriodDaysJSONModel_1 = require("src/hello_assets/src/components/model/common/periodDays/PeriodDaysJSONModel");
const CompositeChartSettingsJSONModel_1 = require("src/hello_assets/src/components/model/compositeChart/CompositeChartSettingsJSONModel");
const AggregationJSONModel_1 = require("src/hello_assets/src/components/model/common/AggregationJSONModel");
const QueryEventVariantsJSONModel_1 = require("src/hello_assets/src/components/model/common/queryEventVariant/QueryEventVariantsJSONModel");
class CompositeChartJSONModel {
    constructor(serializedState) {
        this.eventsJSONModel = new QueryEventVariantsJSONModel_1.QueryEventVariantsJSONModel();
        this.periodDaysJSONModel = new PeriodDaysJSONModel_1.PeriodDaysJSONModel();
        this.sequenceJSONModel = new AutoSequenceJSONModel_1.AutoSequenceJSONModel();
        this.chartSettingsJSONModel = new CompositeChartSettingsJSONModel_1.CompositeChartSettingsJSONModel();
        this.aggregationJSONModel = new AggregationJSONModel_1.AggregationJSONModel();
        this.reset = () => {
            this.eventsJSONModel.reset();
            this.periodDaysJSONModel.reset();
            this.sequenceJSONModel.reset();
            this.chartSettingsJSONModel.reset();
            this.aggregationJSONModel.reset();
        };
        this.overwriteFromSerializedStateString = (serializedState) => {
            let parsed = undefined;
            try {
                if (lodash_1.default.isString(serializedState)) {
                    parsed = JSON.parse(serializedState);
                }
            }
            catch (e) {
            }
            return this.overwriteFromSerializedState(parsed);
        };
        this.overwriteFromSerializedState = (serializedState) => {
            if (serializedState) {
                this.eventsJSONModel.overwriteFromSerializedState(serializedState.events);
                this.periodDaysJSONModel.overwriteFromSerializedState(serializedState.period);
                this.sequenceJSONModel.overwriteFromSerializedState(serializedState.sequence);
                this.chartSettingsJSONModel.overwriteFromSerializedState(serializedState.chart);
                this.aggregationJSONModel.overwriteFromSerializedState(serializedState.aggregation);
            }
        };
        this.serialize = () => {
            return {
                events: this.eventsJSONModel.serialize(),
                period: this.periodDaysJSONModel.serialize(),
                sequence: this.sequenceJSONModel.serialize(),
                chart: this.chartSettingsJSONModel.serialize(),
                aggregation: this.aggregationJSONModel.serialize(),
            };
        };
        this.getEventsJSONModel = () => this.eventsJSONModel;
        this.getPeriodDaysJSONModel = () => this.periodDaysJSONModel;
        this.getSequenceJSONModel = () => this.sequenceJSONModel;
        this.getChartSettingsJSONModel = () => this.chartSettingsJSONModel;
        this.getCompositeChartAggregationJSONModel = () => this.aggregationJSONModel;
        this.reset();
        this.overwriteFromSerializedState(serializedState);
    }
}
exports.CompositeChartJSONModel = CompositeChartJSONModel;
////////////////////////////////////////////////
// URL state validator
////////////////////////////////////////////////
CompositeChartJSONModel.isModelEmpty = (serializedState) => {
    const compositeChartJSONModel = new CompositeChartJSONModel(serializedState);
    return !compositeChartJSONModel.getEventsJSONModel().hasFilledEvents();
};
CompositeChartJSONModel.makeModelStateClean = (serializedState) => {
    const compositeChartJSONModel = new CompositeChartJSONModel(serializedState);
    compositeChartJSONModel.getEventsJSONModel().removeNotFilledQueryEventVariants();
    return compositeChartJSONModel.serialize();
};
